export default "5.0.0-beta.3";